// import React, { useCallback, useEffect, useRef, useState } from "react";
// // import Input from "../../../../components/input/index";
// import { Image } from "react-bootstrap";
// import CommomButton from ".././../../../components/common-button/index";
// import { Input } from "reactstrap";
// import { pdfjs } from "react-pdf";
// import { PDFDocument } from "pdf-lib";
// // import useImage from "use-image";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Zoom, Pagination, EffectFade, Navigation } from "swiper/modules";
// import {
//   Upload04Icon,
//   // ArrowRightIcon,
//   // ArrowLeftIcon,
// } from "../../../../icons/icons";
// import "swiper/css";
// import "swiper/css/zoom";
// import "swiper/css/effect-fade";
// import "swiper/css/pagination";
// import "swiper/css/navigation";

// // const URLImage = ({ image }) => {
// //   const [img] = useImage(image);
// //   return <Image image={img} x={0} y={0} className="" />;
// // };

// const InsertPdf = ({
//   // stepper,
//   // totalPages,
//   fileType,
//   setFileType,
//   file,
//   setFile,
//   pagesUrl,
//   setPagesUrl,
//   // inputdata,
//   // formData,
//   setFileName,
//   // fileName,
//   selectedImage,
//   setSelectedImage,
//   // originalFile,
//   setOriginalFile,
//   setFileUrl,
//   // validateStep,
//   // step,
//   setTotalPages,
//   fileUrl,
//   campaingDetails,
//   setSnackbarMessage,
//   setSnackbarVariant,
//   setShowSnackbar,
// }) => {
//   pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
//   // const stageRef = useRef(null);

//   // const [currentPage, setCurrentPage] = useState(1);
//   const selectableMaxFileSize = 1024 * 1024 * 100;
//   const [loading, setLoading] = useState(false);
//   // console.log("Loading ::::::::::::", originalFile);
//   console.log("FIle ::::::::::::", file);

//   const generateImageToPdf = useCallback(
//     async (file, url) => {
//       const imageBytes = await fetch(
//         file ? URL.createObjectURL(file) : url
//       ).then((res) => res.arrayBuffer());
//       setPagesUrl(
//         new File([imageBytes], "converted-file.png", {
//           type: "image/png",
//         })
//       );
//       const pdfDoc = await PDFDocument.create();
//       let image;
//       if (file) {
//         if (file.type === "image/png") {
//           image = await pdfDoc.embedPng(imageBytes);
//         } else {
//           image = await pdfDoc.embedJpg(imageBytes);
//         }
//       } else if (url) {
//         // If a URL is provided, you may need to check for file extension or other means to determine if it's PNG or JPG
//         const fileExtension = url.split(".").pop().toLowerCase();

//         // console.log("File Extention : ", fileExtension);
//         if (fileExtension === "png") {
//           image = await pdfDoc.embedPng(imageBytes);
//         } else if (fileExtension === "jpg" || fileExtension === "jpeg") {
//           image = await pdfDoc.embedJpg(imageBytes);
//         } else {
//           throw new Error(
//             "Unsupported URL file type. Only PNG and JPEG URLs are allowed."
//           );
//         }
//       }

//       const page = pdfDoc.addPage();
//       page.setHeight(image.height);
//       page.setWidth(image.width);
//       page.drawImage(image, {
//         x: page.getWidth() / 2 - image.width / 2,
//         y: page.getHeight() / 2 - image.height / 2,
//       });
//       const pdfBytes = await pdfDoc.save();
//       setFile(
//         new File([pdfBytes], "converted-file.pdf", {
//           type: "application/pdf;charset=utf-8",
//         })
//       );
//     },
//     [setFile, setPagesUrl]
//   );

//   useEffect(() => {
//     const loadFileFromUrl = async (url, type) => {
//       try {
//         if (type === "application/pdf") {
//           const loadingTask = pdfjs.getDocument(url);
//           const pdf = await loadingTask.promise;
//           const pages = pdf.numPages;

//           // console.log("PAGES : ", pages);
//           setTotalPages(pages);
//           let pagesData = [];
//           for (let i = 0; i < pdf.numPages; i++) {
//             const page = await pdf.getPage(i + 1);
//             const canvas = document.createElement("canvas");
//             const context = canvas.getContext("2d");
//             const viewport = page.getViewport({ scale: 1 });
//             canvas.width = viewport.width;
//             canvas.height = viewport.height;
//             const renderContext = {
//               canvasContext: context,
//               viewport: viewport,
//             };
//             await page.render(renderContext).promise;
//             const dataURL = canvas.toDataURL("image/png");
//             pagesData.push({
//               base64: dataURL,
//               height: viewport.height,
//               width: viewport.width,
//             });
//           }
//           const response = await fetch(url);
//           const blob = await response.blob();
//           const file = new File([blob], "sample.pdf", {
//             type: "application/pdf",
//           });

//           // Set the actual File object
//           setFile(file);
//           setPagesUrl(pagesData);
//           setLoading(false);
//         } else if (type.startsWith("image")) {
//           // console.log("Image");
//           setSelectedImage(url);
//           setOriginalFile(url);
//           generateImageToPdf("", url);
//           setLoading(false);
//         }
//       } catch (error) {
//         console.error("Error Fetching Pdf. ", error);
//         setLoading(false);
//       }
//     };

//     // console.log("loadFileFromUrl : ");
//     if (fileUrl && campaingDetails.status === "drafted") {
//       setLoading(true);
//       const newfileUrl = `${fileUrl}`;
//       loadFileFromUrl("https://s3.eu-central-2.wasabisys.com/invitewala-data/Staging/Campaigns/1766568198.pdf", fileType);
//       // setLoading(false);
//     }
//   }, [
//     fileType,
//     setPagesUrl,
//     setTotalPages,
//     setSelectedImage,
//     setFile,
//     campaingDetails,
//     fileUrl,
//     selectedImage,
//     generateImageToPdf,
//     setOriginalFile,
//   ]);

//   useEffect(() => {
//     // console.log(
//     //   "pdfToCanvaspdfToCanvaspdfToCanvaspdfToCanvas ::::::::::::::::::::::::::::::::::::"
//     // );

//     if (!file) {
//       setLoading(false);
//       return;
//     }

//     const pdfToCanvas = async (filedata) => {
//       setLoading(true);
//       const loadingTask = pdfjs.getDocument(
//         window.URL.createObjectURL(filedata)
//       );
//       const pdf = await loadingTask.promise;
//       const pages = pdf.numPages;
//       setTotalPages(pages);
//       let pagesData = [];
//       for (let i = 0; i < pdf.numPages; i++) {
//         const page = await pdf.getPage(i + 1);
//         const canvas = document.createElement("canvas");
//         const context = canvas.getContext("2d");
//         const viewport = page.getViewport({ scale: 1 });
//         canvas.width = viewport.width;
//         canvas.height = viewport.height;
//         const renderContext = {
//           canvasContext: context,
//           viewport: viewport,
//         };
//         await page.render(renderContext).promise;
//         const dataURL = canvas.toDataURL("image/png");
//         pagesData.push({
//           base64: dataURL,
//           height: viewport.height,
//           width: viewport.width,
//         });
//       }

//       // console.log("Page data : ", pagesData);
//       setPagesUrl(pagesData);
//       setLoading(false);
//     };

//     if (file) {
//       pdfToCanvas(file);
//       // console.log("pdfToCanvaspdfToCanvaspdfToCanvaspdfToCanvas :::::::");
//     } else {
//       setLoading(false);
//       // console.log("pdfToCanvas Else :::::::");
//     }
//   }, [file, setPagesUrl, setTotalPages]);

//   const fileInputRef = useRef(null);

//   const handleButtonClick = () => {
//     fileInputRef.current.click();
//   };

//   const handleFileChange = async (file) => {
//     if (file.size > selectableMaxFileSize) {
//       if (!file) {
//         setFile("");
//         setTotalPages(0);
//       }
//       // Show error message here
//       setSnackbarMessage("File Size is Not more Than 100mb");
//       setSnackbarVariant("danger");
//       setShowSnackbar(true);
//     } else {
//       setFileUrl("");
//       if (file.type === "application/pdf") {
//         setFile(file);
//         setOriginalFile(file);
//         setFileType(file.type);
//         setFileName(file.name);
//       } else if (
//         file.type === "image/jpeg" ||
//         file.type === "image/png" ||
//         file.type === "image/jpg"
//       ) {
//         // console.log("File . type :: ", file.type);
//         setSelectedImage(URL.createObjectURL(file));
//         setFileName(file.name);
//         setOriginalFile(file);
//         generateImageToPdf(file, "");
//         setFileType(file.type);
//       } else {
//         // Show error message here
//         if (!file) {
//           setFile("");
//           setTotalPages(0);
//         }
//         setSnackbarMessage("Upload Valid Document(PDF or Image)");
//         setSnackbarVariant("danger");
//         setShowSnackbar(true);
//       }
//     }

//     fileInputRef.current.value = "";
//   };

//   // const resetInput = () => {
//   //   setFile("");
//   //   setTotalPages(0);
//   //   setFileType("");
//   //   setFileName("");
//   //   setSelectedImage(null);
//   //   setOriginalFile("");
//   // };

//   const prevRef = React.useRef(null);
//   const nextRef = React.useRef(null);

//   const isPagesReady = Array.isArray(pagesUrl) && pagesUrl.length > 0;
//   const hasFile = !!file;
//   console.log("HASS FILE", hasFile);

//   return (
//     <>
//       <div className="bg-white rounded-2 overflow-hidden common-shadow p-4 mb-4">
//         <div className="import-file-content">
//           <div className=" d-flex align-items-center justify-content-between gap-4 import-file-header mb-3">
//             <div>
//               <h5 className="fw-medium">Select PDF or Image File</h5>
//               {/* <p>Select method to import contacts</p> */}
//             </div>

//             <div className={file ? "d-block" : "d-none"}>
//               <CommomButton
//                 type="submit"
//                 icon={
//                   <Upload04Icon
//                     width={20}
//                     height={20}
//                     color="#ffffff"
//                     strokeWidth="2.2"
//                   />
//                 }
//                 onClick={handleButtonClick}
//                 className="btn-primary primary-shadow select-pdf-icon"
//                 subClassName="justify-content-center"
//               />
//               <Input
//                 type="file"
//                 className="d-none"
//                 name="file_name"
//                 id="media-upload"
//                 innerRef={fileInputRef}
//                 onChange={async (e) => {
//                   handleFileChange(e.target.files[0]);
//                 }}
//               />
//             </div>
//           </div>
//           { (loading || (hasFile && !isPagesReady)) ? (
//               // LOADER
//               <div className="d-flex align-items-center justify-content-center h-100 w-100">
//                 <div className="loading-container">
//                   <div className="loading-progress"></div>
//                 </div>
//               </div>
//             ) : isPagesReady ? (
//               // PREVIEW
//               <div className="d-flex align-items-center justify-content-center gap-4">
//                 {fileType === "application/pdf" ? (
//                   <Swiper
//                     pagination={{ type: "fraction" }}
//                     navigation={{ prevEl: prevRef.current, nextEl: nextRef.current }}
//                     onBeforeInit={(swiper) => {
//                       swiper.params.navigation.prevEl = prevRef.current;
//                       swiper.params.navigation.nextEl = nextRef.current;
//                     }}
//                     zoom
//                     effect="fade"
//                     modules={[Pagination, Zoom, EffectFade, Navigation]}
//                     className="mySwiper mx-0 import-file-preview"
//                   >
//                     {pagesUrl.map((item, i) => (
//                       <SwiperSlide key={i} className="border rounded-1 overflow-hidden">
//                         <div className="swiper-zoom-container">
//                           <Image
//                             src={item?.base64}
//                             className="img-fluid object-fit-cover"
//                             // ensure loader hides only after image decode
//                             onLoadingComplete={() => setLoading(false)}
//                             alt={`Page ${i + 1}`}
//                           />
//                         </div>
//                       </SwiperSlide>
//                     ))}
//                   </Swiper>
//                 ) : (
//                   <Image
//                     src={pagesUrl[0]?.base64}
//                     className="img-fluid object-fit-cover"
//                     onLoadingComplete={() => setLoading(false)}
//                     alt="Preview"
//                   />
//                 )}
//               </div>
//             ) : (
//               // UPLOAD PLACEHOLDER
//               <div
//                 className={`upload-contnt d-flex align-items-center justify-content-center cursor-pointer rounded-2 ${
//                   !loading && file ? null : "w-100"
//                 }`}
//                 onClick={handleButtonClick}
//               >
//                 <div>
//                   <span className="rounded-2 d-flex align-items-center justify-content-center mx-auto upload-icon">
//                     <Upload04Icon width={22} height={22} color="#6d6b77" strokeWidth="2" />
//                   </span>
//                   <h5 className="fw-medium pt-2">Upload PDF or Image file</h5>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       {/* <Row>
//         <Col xl="12" className="mb-25 ">
//           <div className="mb-1">
//             {loading || file ? (
//               <Row className="pt-4 align-items-start justify-content-center">
//                 <Col lg="3" sm="3" xs="4">
//                   <div className="contain_image h-100">
//                     {loading ? (
//                       <div className="loading-container">
//                         <div className="loading-progress"></div>
//                       </div>
//                     ) : file ? (
//                       <div className="text-start loading-container">
//                         {console.log("File Type ; ", fileType)}
//                         {fileType === "application/pdf" ? (
//                           <img
//                             src={pagesUrl[currentPage - 1]?.base64}
//                             alt="thumbnail"
//                             width={42}
//                             height={42}
//                           />
//                         ) : (
//                           <img
//                             src={selectedImage}
//                             alt="thumbnail1"
//                             width={42}
//                             height={42}
//                           />
//                         )}
//                       </div>
//                     ) : null}
//                     <div className="d-flex justify-content-between mt-2 mx-25">
//                       <p>{fileName}</p>
//                       <img
//                         src="/images/image-folder-icon/deletefile-icon.svg"
//                         alt="delete-file"
//                         width={20}
//                         height={20}
//                         // onClick={resetInput}
//                         className="curser-pointer"
//                       />
//                     </div>
//                   </div>
//                 </Col>
//                 <Col lg="9" sm="9" xs="8" className="">
//                   <div className="d-flex align-items-center gap-1 set-pdf">
//                     {currentPage > 1 && (
//                       <div>
//                         <ChevronLeft
//                           color="#624bff"
//                           size={35}
//                           onClick={() => {
//                             setCurrentPage(currentPage - 1);
//                           }}
//                         />
//                       </div>
//                     )}
//                     <div className="d-flex align-items-center justify-content-center uploading_image">
//                       <div className=" w-100 h-100">
//                         {loading ? (
//                           <div className="d-flex align-items-center justify-content-center h-100 w-100">
//                             <div className="loading-container">
//                               <div className="loading-progress"></div>
//                             </div>
//                           </div>
//                         ) : (
//                           <div className="d-flex align-items-center justify-content-center h-100 w-100">
//                             {file && (
//                               <div
//                                 className="w-100 h-100 custom-pdfset"
//                                 style={{ overflow: "auto" }}
//                               >
//                                 <Stage
//                                   id="stage"
//                                   ref={stageRef}
//                                   width={pagesUrl[currentPage - 1]?.width}
//                                   height={pagesUrl[currentPage - 1]?.height}
//                                 >
//                                   <Layer>
//                                     <URLImage
//                                       image={pagesUrl[currentPage - 1]?.base64}
//                                     />
//                                   </Layer>
//                                 </Stage>
//                               </div>
//                             )}
//                           </div>
//                         )}
//                       </div>
//                     </div>
//                     {totalPages === 1 ||
//                       (currentPage < totalPages && (
//                         <div>
//                           <ChevronRight
//                             size={35}
//                             color="#624bff"
//                             onClick={() => {
//                               setCurrentPage(currentPage + 1);
//                             }}
//                           />
//                         </div>
//                       ))}
//                   </div>
//                   <div className="mt-3">
//                     {totalPages > 1 && (
//                       <div
//                         align="center"
//                         style={{
//                           color: "#624bff",
//                           background: "white",
//                         }}
//                       >
//                         Page {currentPage} of {totalPages}
//                       </div>
//                     )}
//                   </div>
//                 </Col>
//               </Row>
//             ) : (
//               <Row className="pt-4 align-items-center justify-content-center">
//                 <Col lg="9" sm="9" xs="8">
//                   <div
//                     className="d-flex align-items-center justify-content-center uploading_image"
//                     onClick={handleButtonClick}
//                     style={{ cursor: "pointer" }}
//                   >
//                     <div className=" w-100 h-100">
//                       <div className="d-flex flex-column gap-3 align-items-center justify-content-center h-100 w-100">
//                         <img
//                           src="/images/image-folder-icon/upload-doc-icon.svg"
//                           alt="uploading"
//                           className="mx-auto"
//                           fill
//                         />
//                         <h3 className="text-muted">Upload Document</h3>
//                       </div>
//                     </div>
//                   </div>
//                 </Col>
//               </Row>
//             )}
//           </div>
//         </Col>
//       </Row> */}
//     </>
//   );
// };

// export default InsertPdf;

import React, { useCallback, useEffect, useRef, useState } from "react";
import { Image as BootstrapImage } from "react-bootstrap";
import { Input } from "reactstrap";
import CommomButton from ".././../../../components/common-button/index";
import { Swiper, SwiperSlide } from "swiper/react";
import { Zoom, Pagination, Navigation } from "swiper/modules";
import { pdfjs } from "react-pdf";
import { Upload04Icon } from "../../../../icons/icons";

import "swiper/css";
import "swiper/css/zoom";
import "swiper/css/pagination";
import "swiper/css/navigation";

/* =========================
   PDF WORKER (SET ONCE)
========================= */
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const InsertPdf = ({
  file,
  setFile,
  fileType,
  setFileType,
  totalPages,
  setTotalPages,
  fileUrl,
  campaingDetails,
  setSnackbarMessage,
  setSnackbarVariant,
  setShowSnackbar,
  setPagesUrl,
}) => {
  // Our official number sends invitations as a template with a PDF attachment.
  // The per-guest personalisation for images runs through a Node path the
  // official gateway has no endpoint for, so an image campaign on that client
  // would be refused at the very end, after the whole campaign was built.
  // Refuse the upload instead, where the customer can still change course.
  // The campaign's own choice, made on step one. Falls back to the client
  // event only for campaigns created before the builder asked, whose
  // sender_type was not written until finalise.
  const officialSender =
    (campaingDetails?.sender_type ||
      campaingDetails?.client_event?.sender_type) === "official";

  const fileInputRef = useRef(null);
  const canvasRefs = useRef([]);

  const renderTasksRef = useRef({});

  const [pdfInstance, setPdfInstance] = useState(null);
  const [, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);

  const [, setSwiperInstance] = useState(null);

  // console.log(currentPage, swiperInstance);

  const MAX_SIZE = 1024 * 1024 * 100; // 100MB

  /* =========================
     LOAD PDF (ONCE)
  ========================= */
  // const loadPdf = async (source) => {
  //   try {
  //     setLoading(true);

  //     const buffer =
  //       source instanceof File
  //         ? await source.arrayBuffer()
  //         : await fetch(source).then((r) => r.arrayBuffer());

  //     const pdf = await pdfjs.getDocument({ data: buffer }).promise;

  //     renderTasksRef.current = {};
  //     canvasRefs.current = [];

  //     setPdfInstance(pdf);
  //     setTotalPages(pdf.numPages);
  //     setCurrentPage(1);

  //     setTimeout(() => renderPage(1), 0);
  //   } catch (err) {
  //     console.error(err);
  //     setSnackbarMessage("Failed to load PDF");
  //     setSnackbarVariant("danger");
  //     setShowSnackbar(true);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const generatePagesUrl = async (buffer) => {
    // const buffer =
    //   source instanceof File
    //     ? await source.arrayBuffer()
    //     : await fetch(source).then((r) => r.arrayBuffer());

    const pdf = await pdfjs.getDocument({ data: buffer }).promise;

    const pages = [];

    for (let i = 1; i <= pdf.numPages; i++) {
      const page = await pdf.getPage(i);

      // IMPORTANT: keep scale = 1 (reference size)
      const viewport = page.getViewport({ scale: 1 });

      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      canvas.width = viewport.width;
      canvas.height = viewport.height;

      await page.render({
        canvasContext: ctx,
        viewport,
      }).promise;

      pages.push({
        base64: canvas.toDataURL("image/jpeg", 0.7), // smaller & faster than png
        width: viewport.width,
        height: viewport.height,
      });
    }

    return {
      pagesUrl: pages,
      totalPages: pdf.numPages,
      buffer,
    };
  };

  const loadPdf = useCallback(
    async (source) => {
      try {
        setLoading(true);

        // cleanup old renders
        renderTasksRef.current = {};
        canvasRefs.current = [];

        // const buffer =
        //   source instanceof File
        //     ? await source.arrayBuffer()
        //     : await fetch(source).then((r) => r.arrayBuffer());

        let buffer;
        let fileObj = null;

        if (source instanceof File) {
          buffer = await source.arrayBuffer();
          fileObj = source; // reuse
        } else {
          buffer = await fetch(source).then((r) => r.arrayBuffer());

          // Create File ONLY for URL-based PDFs
          fileObj = new File([buffer], "document.pdf", {
            type: "application/pdf",
          });
        }

        const viewerBuffer = buffer.slice(0);
        const editorBuffer = buffer.slice(0);

        const pdf = await pdfjs.getDocument({ data: viewerBuffer }).promise;

        setPdfInstance(pdf);
        setTotalPages(pdf.numPages);
        setCurrentPage(1);
        setFile(fileObj);

        const { pagesUrl } = await generatePagesUrl(editorBuffer);
        setPagesUrl(pagesUrl);
      } catch (err) {
        console.error(err);
        setSnackbarMessage("Failed to load PDF");
        setSnackbarVariant("danger");
        setShowSnackbar(true);
      } finally {
        setLoading(false);
      }
    },
    [
      setTotalPages,
      setSnackbarMessage,
      setSnackbarVariant,
      setShowSnackbar,
      setFile,
      setPagesUrl,
    ]
  );

  /* =========================
     RENDER SINGLE PAGE
  ========================= */
  const renderPage = async (pageNumber) => {
    if (!pdfInstance) return;

    const canvas = canvasRefs.current[pageNumber - 1];
    if (!canvas) return;

    // Cancel previous render if exists
    if (renderTasksRef.current[pageNumber]) {
      try {
        renderTasksRef.current[pageNumber].cancel();
      } catch (e) {}
    }

    const page = await pdfInstance.getPage(pageNumber);
    const viewport = page.getViewport({ scale: 1.2 });

    const ctx = canvas.getContext("2d");

    canvas.width = viewport.width;
    canvas.height = viewport.height;

    const renderTask = page.render({
      canvasContext: ctx,
      viewport,
    });

    renderTasksRef.current[pageNumber] = renderTask;

    try {
      await renderTask.promise;
    } catch (err) {
      // Ignore cancelled render
      if (err?.name !== "RenderingCancelledException") {
        console.error(err);
      }
    }
  };

  /* =========================
     HANDLE FILE URL (DRAFT)
  ========================= */
  useEffect(() => {
    if (fileUrl && campaingDetails?.status === "drafted") {
      const loadFileFromUrl = async () => {
        if (fileType === "application/pdf") {
          await loadPdf(fileUrl);
        } else if (fileType && fileType.startsWith("image/")) {
          // Handle image loading from URL
          setLoading(true);
          try {
            const img = new Image();
            img.crossOrigin = "anonymous";
            img.onload = () => {
              setImagePreview(fileUrl);
              setPdfInstance(null);
              setTotalPages(1);
              
              // Create canvas to convert image to base64
              const canvas = document.createElement("canvas");
              canvas.width = img.width;
              canvas.height = img.height;
              const ctx = canvas.getContext("2d");
              ctx.drawImage(img, 0, 0);
              
              // Convert to base64 and populate pagesUrl
              const base64 = canvas.toDataURL("image/jpeg", 0.7);
              setPagesUrl([{
                base64: base64,
                width: img.width,
                height: img.height,
              }]);
              
              // Create File object from URL
              fetch(fileUrl)
                .then(res => res.blob())
                .then(blob => {
                  const file = new File([blob], "image.jpg", { type: fileType });
                  setFile(file);
                })
                .catch(err => console.error("Error creating file from URL:", err))
                .finally(() => setLoading(false));
            };
            img.onerror = () => {
              console.error("Error loading image from URL");
              setLoading(false);
            };
            img.src = fileUrl;
          } catch (err) {
            console.error("Error loading image:", err);
            setLoading(false);
          }
        }
      };
      
      loadFileFromUrl();
    }
  }, [fileUrl, campaingDetails, fileType, loadPdf, setPagesUrl, setFile, setTotalPages]);

  /* =========================
     HANDLE FILE UPLOAD
  ========================= */
  const handleFileChange = async (file) => {
    if (!file) return;
    
    if (file.size > MAX_SIZE) {
      setSnackbarMessage("File size must be under 100MB");
      setSnackbarVariant("danger");
      setShowSnackbar(true);
      return;
    }

    if (officialSender && file.type !== "application/pdf") {
      setSnackbarMessage(
        "This client sends from our official WhatsApp number, which only carries PDF invitations. Upload a PDF, or switch the client back to your own number."
      );
      setSnackbarVariant("danger");
      setShowSnackbar(true);
      fileInputRef.current.value = "";
      return;
    }

    setFile(file);
    setFileType(file.type);

    if (file.type === "application/pdf") {
      await loadPdf(file);
      setImagePreview(null);
      setSwiperInstance(null);
    } else if (file.type.startsWith("image/")) {
      const imageUrl = URL.createObjectURL(file);
      setImagePreview(imageUrl);
      setPdfInstance(null);
      setTotalPages(1);
      
      // Create an Image object to get dimensions
      const img = new Image();
      img.onload = () => {
        // Create canvas to convert image to base64
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        
        // Convert to base64 and populate pagesUrl
        const base64 = canvas.toDataURL("image/jpeg", 0.7);
        setPagesUrl([{
          base64: base64,
          width: img.width,
          height: img.height,
        }]);
      };
      img.src = imageUrl;
    } else {
      setSnackbarMessage("Only PDF or Image files allowed");
      setSnackbarVariant("danger");
      setShowSnackbar(true);
    }

    fileInputRef.current.value = "";
  };

  /* =========================
     SWIPER PAGE CHANGE
  ========================= */
  const handleSlideChange = (swiper) => {
    if (!pdfInstance) return;
    const page = swiper.activeIndex + 1;
    setCurrentPage(page);
    renderPage(page);
  };

  return (
    <div className="bg-white rounded-2 p-4">
      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5>{officialSender ? "Select PDF File" : "Select PDF or Image File"}</h5>

        <CommomButton
          icon={<Upload04Icon width={20} height={20} color="#fff" />}
          onClick={() => fileInputRef.current.click()}
          className="btn-primary"
        />
        <Input
          type="file"
          innerRef={fileInputRef}
          className="d-none"
          accept={officialSender ? "application/pdf" : undefined}
          onChange={(e) => handleFileChange(e.target.files[0])}
        />
      </div>

      {officialSender && (
        <div className="alert alert-info py-2 small">
          This client sends from our official WhatsApp number, which carries PDF
          invitations only. To send an image, switch the client back to your own
          WhatsApp number.
        </div>
      )}

      {/* LOADER */}
      {loading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="loading-container">
            <div className="loading-progress"></div>
          </div>
        </div>
      )}

      {/* IMAGE PREVIEW */}
      {!loading && imagePreview && (
        <div className="text-center">
          <BootstrapImage src={imagePreview} fluid />
        </div>
      )}

      {/* PDF PREVIEW */}
      {!loading && pdfInstance && (
        <Swiper
          zoom
          pagination={{ type: "fraction" }}
          navigation
          modules={[Zoom, Pagination, Navigation]}
          onSlideChange={handleSlideChange}
          onSwiper={(swiper) => {
            setSwiperInstance(swiper);

            // IMPORTANT: render first page AFTER swiper mounts slides
            setTimeout(() => {
              renderPage(1);
            }, 0);
          }}
        >
          {Array.from({ length: totalPages }).map((_, i) => (
            <SwiperSlide key={i}>
              <div className="swiper-zoom-container d-flex justify-content-center">
                <canvas ref={(el) => (canvasRefs.current[i] = el)} />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      )}

      {/* EMPTY STATE */}
      {!loading && !pdfInstance && !imagePreview && (
        <div
          className="text-center cursor-pointer"
          onClick={() => fileInputRef.current.click()}
        >
          <Upload04Icon width={40} height={40} color="#999" />
          <p className="mt-2">Upload PDF or Image</p>
        </div>
      )}
    </div>
  );
};

export default InsertPdf;
